import React from 'react';
import { fetchUtils, Admin, Resource, Delete } from 'admin-on-rest';
import { jsonServerRestClient } from './rest'
import authClient from './authClient';

import { UserList, UserEdit, UserCreate } from './resources/users';
import { ProfileList, ProfileEdit, ProfileCreate } from './resources/profiles';
import { ClientList, ClientEdit, ClientCreate, ClientShow } from './resources/clients';
import { LevyList, LevyEdit, LevyCreate } from './resources/levies';
import { ContractList, ContractEdit, ContractCreate, ContractShow } from './resources/contracts';

import frenchMessages from 'aor-language-french';

const messages = {
    fr: frenchMessages,
};

const httpClient = (url, options = {}) => {
  if (!options.headers) {
      options.headers = new Headers({ Accept: 'application/json' });
  }
  const token = localStorage.getItem('token');
  options.headers.set('Authorization', `Bearer ${token}`);
  return fetchUtils.fetchJson(url, options);
}
const restClient = jsonServerRestClient(process.env.REACT_APP_API_URL, httpClient);

const App = () => (
    <Admin title="FacturationApp" authClient={authClient} restClient={restClient} locale="fr" messages={messages}>
        <Resource name="user" list={UserList} edit={UserEdit} create={UserCreate} remove={Delete}/>
        <Resource name="companyprofile" list={ProfileList} edit={ProfileEdit} create={ProfileCreate} remove={Delete}/>
        <Resource name="client" list={ClientList} edit={ClientEdit} create={ClientCreate} show={ClientShow} remove={Delete}/>
        <Resource name="contract" list={ContractList} edit={ContractEdit} create={ContractCreate} show={ContractShow} remove={Delete}/>
        <Resource name="levy" list={LevyList} edit={LevyEdit} create={LevyCreate} remove={Delete}/>
    </Admin>
);

export default App;


// WEBPACK FOOTER //
// src/App.js